const StatusMessage = ({ error, disconnectText, showConnectingText, showTimeoutText, analyzeAudioError, retryNoticeText, thinking, thinkingText, idleMessage, isTalking, isListening, isPaused, listeningVariant = 'dots' }) => {

    let message = "";
    let icon = null;

    if (error) {
        message = error;
    } else if (disconnectText) {
        message = disconnectText;
    } else if (retryNoticeText) {
        message = retryNoticeText;
    } else if (thinking) {
        message = thinkingText || "Thinking...";
        icon = <span className="listening-dots" aria-hidden>
                <span></span><span></span><span></span><span></span><span></span>
            </span>
    } else if (isTalking) {
        message = "Aris is talking";
        icon = (
            <span className="talking-eq" aria-hidden>
                <span></span><span></span><span></span><span></span><span></span>
            </span>
        );
    } else if (showConnectingText) {
        message = "Connecting to Aris...";
    } else if (showTimeoutText) {
        message = showTimeoutText;
    } else if (analyzeAudioError) {
        message = analyzeAudioError;
    } else if (isPaused) {
        message = "Session is paused";
    } else if (isListening) {
        message = "Aris is listening";
        icon = listeningVariant === 'bars' ? (
            <span className="listening-bars" aria-hidden>
                <span></span><span></span><span></span><span></span><span></span>
            </span>
        ) : (
            <span className="listening-dots" aria-hidden>
                <span></span><span></span><span></span><span></span><span></span>
            </span>
        );
    } else if (idleMessage) {
        message = idleMessage;
    }

    if (!message) return null;

    return (
        <div className="coaching-llm-text-container">
            {icon && <span className="coaching-icon">{icon}</span>}
            <p className="coaching-error-message">{message}</p>
        </div>
    );
};

export default StatusMessage;